// Hiệu ứng quay random thưởng (port từ 2026-ld-30-4/Frame2).
// Nhấp nháy các .effect__item (sprite quà trong .F1-reward-list) rồi dừng ở phần thưởng trúng.
// Dùng window.libraryMainsite.promotion + config prodTemplate (assets/main/html/configProduction).

class Core {
	constructor() {
		this.currentTimeout = null;
	}
	wait(timeout) {
		if (this.currentTimeout) clearTimeout(this.currentTimeout);
		return new Promise((resolve) => {
			this.currentTimeout = setTimeout(resolve, timeout);
		});
	}
}

window.addEventListener("load", function () {
	const dndPromotion = window.libraryMainsite && window.libraryMainsite.promotion;
	// Guard: lib chưa có module promotion hoặc chưa cấu hình prodTemplate thì bỏ qua (không crash)
	if (typeof dndPromotion !== "function" || typeof prodTemplate === "undefined") return;

	let globalCount;

	async function animationRandom(count, elementResult) {
		const listItem = $(".effect__item");

		// reset: tắt active, làm mờ tất cả
		listItem.removeClass("MS__active").addClass("MS__off");

		// hết vòng → dừng ở ô trúng (data-stt === index thưởng)
		if (globalCount < 1) {
			const getItemResult = listItem.filter(function () {
				return $(this).data("stt") === elementResult;
			});
			$(getItemResult).removeClass("MS__off").addClass("MS__active");
			return;
		}

		globalCount = count - 1;
		const randomNumber = Math.floor(Math.random() * listItem.length);
		$(listItem[randomNumber]).removeClass("MS__off").addClass("MS__active");

		await new Core().wait(150);
		animationRandom(globalCount, elementResult);
	}

	dndPromotion({
		url: prodTemplate.url,
		debug: prodTemplate.debug,
		directory: prodTemplate.directory,
		items: prodTemplate.items,
		names: prodTemplate.names,
		config: {
			timeWait: 1700,
		},
		animResult: function (listPrize) {
			var displayPrize = listPrize[0];
			animationRandom(10, displayPrize.indexImg);
		},
		callback: function () {
			if (typeof prodTemplate.fnPromotion === "function") prodTemplate.fnPromotion();
			globalCount = 10;
			$(".effect__item").removeClass("MS__active").removeClass("MS__off");
		},
	});
});

// Nhạc nền: autoplay bị chặn tới khi user tương tác lần đầu
window.addEventListener("load", function () {
	var musicUrl = $("#MS__wrapper").data("audio");
	if (!musicUrl) return;

	$("body").append('<audio id="backgroundMusic" loop><source src="' + musicUrl + '" type="audio/mpeg"></audio>');
	var audio = document.getElementById("backgroundMusic");
	var $btnMusic = $(".btn-music");
	var hasInteracted = false;

	var syncBtnState = function () {
		$btnMusic
			.toggleClass("MS__sprite-F1-musicon", !audio.paused)
			.toggleClass("MS__sprite-F1-musicoff", audio.paused);
	};
	audio.addEventListener("play", syncBtnState);
	audio.addEventListener("pause", syncBtnState);
	syncBtnState();

	$btnMusic.on("click", function (e) {
		e.preventDefault();
		hasInteracted = true;
		if (audio.paused) audio.play().catch(function () {});
		else audio.pause();
	});

	var autoPlayHandler = function () {
		if (hasInteracted) return;
		hasInteracted = true;
		audio.play().catch(function () {});
		$(document).off("click touchstart", autoPlayHandler);
	};
	$(document).on("click touchstart", autoPlayHandler);

	document.addEventListener("visibilitychange", function () {
		if (document.hidden) audio.pause();
		else if (hasInteracted) audio.play().catch(function () {});
	});
});
